<template>
  <div id="app">
    <Navbar />

    <!-- <div style="flex: 1">
      <router-view style="height: 100%; flex: 1; overflow: auto" />
    </div> -->

    <router-view style="" />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";

export default {
  components: {
    Navbar,
  },
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
  display: flex;
  flex-direction: column;

  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue